import React from 'react';
import { PackagePlus, Navigation, Zap, BarChart3, ArrowRight } from 'lucide-react';
import { workflowSteps } from '../../data/mock';

const iconMap = {
  PackagePlus,
  Navigation,
  Zap,
  BarChart3
};

const WorkflowSection = () => {
  return (
    <section id="workflow" className="py-32 relative overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 bg-[#000000]" />
      <div className="absolute top-0 left-1/4 w-[400px] h-[400px] bg-[#00FFD1]/5 rounded-full blur-[150px]" />
      
      <div className="relative max-w-7xl mx-auto px-6 lg:px-[7.6923%]">
        {/* Section Header */}
        <div className="text-center mb-20">
          <span className="text-[#00FFD1] text-sm font-medium tracking-wider uppercase">The Field Workflow</span>
          <h2 className="text-4xl md:text-5xl font-semibold text-white mt-4 leading-tight">
            From Load to Ledger.
            <span className="block text-white/50">Four Simple Steps.</span>
          </h2>
        </div>
        
        {/* Timeline */}
        <div className="relative">
          {/* Connection Line */}
          <div className="hidden lg:block absolute top-1/2 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#00FFD1]/30 to-transparent" />
          
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-4">
            {workflowSteps.map((step, index) => {
              const Icon = iconMap[step.icon];
              return (
                <div key={step.step} className="relative group">
                  {/* Step Card */}
                  <div className="bg-[#121212] border border-white/10 p-8 h-full transition-all duration-400 group-hover:border-[#00FFD1]/40 group-hover:bg-[#121212]/80">
                    {/* Step Number */}
                    <div className="flex items-center gap-4 mb-6">
                      <div className="w-12 h-12 bg-[#00FFD1] flex items-center justify-center text-black font-bold text-xl">
                        {step.step}
                      </div>
                      <div className="flex-1 h-px bg-white/10 group-hover:bg-[#00FFD1]/30 transition-colors" />
                    </div>
                    
                    {/* Icon */}
                    <div className="w-14 h-14 bg-[#00FFD1]/10 flex items-center justify-center mb-6 transition-all duration-400 group-hover:bg-[#00FFD1]/20">
                      {Icon && <Icon className="w-7 h-7 text-[#00FFD1]" />}
                    </div>
                    
                    {/* Content */}
                    <h3 className="text-2xl font-semibold text-white mb-4">{step.title}</h3>
                    <p className="text-white/60 leading-relaxed">{step.description}</p>
                  </div>
                  
                  {/* Arrow Connector (Desktop) */}
                  {index < workflowSteps.length - 1 && (
                    <div className="hidden lg:flex absolute -right-4 top-1/2 -translate-y-1/2 z-10 w-8 h-8 bg-[#000000] border border-white/10 items-center justify-center">
                      <ArrowRight className="w-4 h-4 text-[#00FFD1]" />
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WorkflowSection;
